import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

import logo from "../../images/logo.png";

import "../../css/header.css";

const Header = (props) => {
    const [resources, setResources] = useState({});
    const [menuOpen, setMenuOpen] = useState(false);
    let navigate = useNavigate();
    const { language } = useParams();

    let languageNavPath = props.pagePath || "home";

    useEffect(() => {
        requestResources();
    }, [language]);

    const requestResources = async () => {
        try {
            const res = await axios.get(`form/resources/${language}`);
            setResources(res.data?.translation);
        } catch (error) {
            console.error(error?.response?.data);
        }
    };

    const handleLanguageSwitch = (lang) => {
        if (lang !== language) {
            navigate(`/${lang}/${languageNavPath}`);
        }
    };

    return (
        <>
            <header className="knitfest-header">
                <div className="left-icons">
                    <a href="https://www.instagram.com/knit.fest/" target="_blank" rel="noopener noreferrer">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            style={{ width: '20px', height: '21px', fill: '#4f5054' }} // any color you want
                        >
                            <circle cx="255.25" cy="256.21" r="70.68"></circle>
                            <path d="M338,54.63H174c-62.72,0-114,51.31-114,114V343.33c0,62.73,51.32,114,114,114H338c62.72,0,114-51.31,114-114V168.67C452,105.94,400.68,54.63,338,54.63ZM255.77,364.07A107.95,107.95,0,1,1,363.71,256.13,107.95,107.95,0,0,1,255.77,364.07Zm109.67-192A25.56,25.56,0,1,1,391,146.5,25.56,25.56,0,0,1,365.44,172.06Z"></path>
                        </svg>
                    </a>
                    <a href={resources?.HeaderUrl_5}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            style={{ width: '20px', height: '21px', fill: '#4f5054' }}  // Instagram pinkish red
                        >
                            <path d="M437.332 80H74.668C51.199 80 32 99.198 32 122.667v266.666C32 412.802 51.199 432 74.668 432h362.664C460.801 432 480 412.802 480 389.333V122.667C480 99.198 460.801 80 437.332 80zM432 170.667L256 288 80 170.667V128l176 117.333L432 128v42.667z"></path>
                        </svg>
                    </a>
                </div>

                <div className="center-logo">
                    <div className="row">
                        <div className="col-md-4 nav-text justify-content-end">
                            <a href={resources?.HeaderUrl_1}>HOME</a>
                            <a href={resources?.HeaderUrl_2}>EVENT</a>
                        </div>
                        <div className="col-md-4">
                            <a href="https://knit-fest.com/">
                                <img src={logo} alt="Knitfest Logo" className="logo" />
                            </a>
                            <div className="event-date">{resources?.HeaderEventDate}</div>
                        </div>
                        <div className="col-md-4 nav-text">
                            <a href={resources?.HeaderUrl_3}>TICKETS</a>
                            <a href={resources?.HeaderUrl_4}>WORKSHOPS</a>
                        </div>
                    </div>
                </div>

                <div className="hamburger" onClick={() => setMenuOpen(true)}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="45" height="45">
                        <rect x="60" y="201" width="392" height="12" fill="currentColor" />
                        <rect x="60" y="301" width="392" height="12" fill="currentColor" />
                    </svg>
                </div>
            </header>

            {/* Offcanvas menu */}
            <div className={`offcanvas-menu ${menuOpen ? 'open' : ''}`}>
                <div className="offcanvas-menu-container ">

                    <div className="offcanvas-header d-flex justify-center align-items-center position-relative px-3 py-2 ">
                        {/* mobile: Social icons stacked vertically */}
                        <div className="d-flex flex-column gap-3 align-items-start position-absolute start-0 mt-5 mobile-social-icons">
                            <a href="https://www.instagram.com/knit.fest/" target="_blank" rel="noopener noreferrer">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: '31px', height: '32px', fill: '#ec167f' }}>
                                    <circle cx="255.25" cy="256.21" r="70.68"></circle>
                                    <path d="M338,54.63H174c-62.72,0-114,51.31-114,114V343.33c0,62.73,51.32,114,114,114H338c62.72,0,114-51.31,114-114V168.67C452,105.94,400.68,54.63,338,54.63ZM255.77,364.07A107.95,107.95,0,1,1,363.71,256.13,107.95,107.95,0,0,1,255.77,364.07Zm109.67-192A25.56,25.56,0,1,1,391,146.5,25.56,25.56,0,0,1,365.44,172.06Z"></path>
                                </svg>
                            </a>
                            <a href={resources?.HeaderUrl_5}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: '31px', height: '32px', fill: '#ec167f' }}>
                                    <path d="M437.332 80H74.668C51.199 80 32 99.198 32 122.667v266.666C32 412.802 51.199 432 74.668 432h362.664C460.801 432 480 412.802 480 389.333V122.667C480 99.198 460.801 80 437.332 80zM432 170.667L256 288 80 170.667V128l176 117.333L432 128v42.667z"></path>
                                </svg>
                            </a>
                        </div>

                        {/* mobile: Logo */}
                        <a className="position-absolute start-50 translate-middle-x visible-mobile" href="https://knit-fest.com/">
                            <img src={logo} alt="Knitfest Logo" className="logo" />
                        </a>

                        {/* Close button */}
                        <button
                            onClick={() => setMenuOpen(false)}
                            className="close-btn btn p-0 position-absolute end-0"
                            aria-label="Close menu"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="25" height="26" className="code-svg">
                                <polygon
                                    points="405 121.8 390.2 107 256 241.2 121.8 107 107 121.8 241.2 256 107 390.2 121.8 405 256 270.8 390.2 405 405 390.2 270.8 256 405 121.8"
                                    fill="#DD087A"
                                />
                            </svg>
                        </button>
                    </div>

                    <div className="offcanvas-content">
                        <div className="menu-column visible-mobile padding-menu-mobile">
                            <p className="menu-title">{resources?.HeaderSideBar1_Title}</p>
                            <ul>
                                <li><a className="sidebar-sub-heading" href={resources?.HeaderUrl_1}>HOME</a></li>
                                <li><a className="sidebar-sub-heading" href={resources?.HeaderUrl_2}>EVENT</a></li>
                                <li><a className="sidebar-sub-heading" href={resources?.HeaderUrl_3}>TICKETS</a></li>
                                <li><a className="sidebar-sub-heading" href={resources?.HeaderUrl_4}>WORKSHOPS</a></li>
                            </ul>
                        </div>
                        <div className="menu-column">
                            <p className="menu-title visible-desktop">{resources?.HeaderSideBar1_Title}</p>
                            <p className="menu-title visible-mobile">{resources?.HeaderSideBar3_Title}</p>
                            <ul>
                                <li><a className="sidebar-sub-heading" href={resources?.HeaderSideBar1_1_Url}>{resources?.HeaderSideBar1_1}</a></li>
                                <li><a className="sidebar-sub-heading" href={resources?.HeaderSideBar1_2_Url}>{resources?.HeaderSideBar1_2}</a></li>
                                <li><a className="sidebar-sub-heading" href={resources?.HeaderSideBar1_3_Url}>{resources?.HeaderSideBar1_3}</a></li>
                                <li><a className="sidebar-sub-heading" href={resources?.HeaderSideBar1_4_Url}>{resources?.HeaderSideBar1_4}</a></li>
                                <li><a className="sidebar-sub-heading" href={resources?.HeaderSideBar1_5_Url}>{resources?.HeaderSideBar1_5}</a></li>
                                <li><a className="sidebar-sub-heading" href={resources?.HeaderSideBar1_6_Url}>{resources?.HeaderSideBar1_6}</a></li>
                            </ul>
                        </div>
                        <div className="menu-column mb-4">
                            <p className="menu-title">{resources?.HeaderSideBar2_Title}</p>
                            <ul>
                                <li><a href={resources?.HeaderSideBar2_1_Url}>{resources?.HeaderSideBar2_1}</a></li>
                                <li><a href={resources?.HeaderSideBar2_2_Url}>{resources?.HeaderSideBar2_2}</a></li>
                                <li><a href={resources?.HeaderSideBar2_3_Url}>{resources?.HeaderSideBar2_3}</a></li>
                            </ul>
                        </div>
                    </div>
                    <a className="visible-desktop" href="https://knit-fest.com/">
                        <img src={logo} alt="Knitfest Logo" className="logo" />
                    </a>
                    <div className="menu-social-icons visible-desktop">
                        <a href="https://www.instagram.com/knit.fest/" target="_blank" rel="noopener noreferrer">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                style={{ width: '28px', height: '29px', fill: '#ec167f' }} // any color you want
                            >
                                <circle cx="255.25" cy="256.21" r="70.68"></circle>
                                <path d="M338,54.63H174c-62.72,0-114,51.31-114,114V343.33c0,62.73,51.32,114,114,114H338c62.72,0,114-51.31,114-114V168.67C452,105.94,400.68,54.63,338,54.63ZM255.77,364.07A107.95,107.95,0,1,1,363.71,256.13,107.95,107.95,0,0,1,255.77,364.07Zm109.67-192A25.56,25.56,0,1,1,391,146.5,25.56,25.56,0,0,1,365.44,172.06Z"></path>
                            </svg>
                        </a>
                        <a href={resources?.HeaderUrl_5}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                style={{ width: '28px', height: '29px', fill: '#ec167f' }}  // Instagram pinkish red
                            >
                                <path d="M437.332 80H74.668C51.199 80 32 99.198 32 122.667v266.666C32 412.802 51.199 432 74.668 432h362.664C460.801 432 480 412.802 480 389.333V122.667C480 99.198 460.801 80 437.332 80zM432 170.667L256 288 80 170.667V128l176 117.333L432 128v42.667z"></path>
                            </svg>
                        </a>
                        <br /><br />
                    </div>
                </div>
            </div>
            <div className="row language-switch">
                <div className="col-md-12 text-end">
                    <span
                        className={`d-inline-block cursor-pointer ${language?.toLowerCase() === 'de' ? 'active' : ''}`}
                        onClick={() => handleLanguageSwitch('de')}
                    >
                        DE
                    </span>
                    <span
                        className={`d-inline-block cursor-pointer ms-3 ${language?.toLowerCase() === 'en' ? 'active' : ''}`}
                        onClick={() => handleLanguageSwitch('en')}
                    >
                        EN
                    </span>
                </div>
            </div>
        </>
    );
};

export default Header;
